export const GTM_ID = 'GTM-WB39ZM' as const;
